<div class="container">
    <div class="header">
        <h1>404</h1>
        <p>Page Not Found</p>
    </div>
    <div id="game-container">
        <canvas #gameCanvas></canvas>
        <div id="score">Score: 0</div>
        <div id="game-over" style="display: none">
            <h2>Game Over</h2>
            <p id="game-over-score">Score: 0</p>
            <p id="high-score">High Score: 0</p>
            <button (click)="handleRestartClick()">Restart</button>
        </div>
    </div>
    <div class="instructions">
        <p>Press <span class="key">Space</span> to jump</p>
        <a routerLink="/" class="home-button">Go to Homepage</a>
    </div>
</div>
